import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { Map, List } from 'immutable';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as attachActions from 'modules/templateAttach';

import * as attachLib from 'libs/attachLib';

import { ExamAttachFile } from 'components';

class CtExamAttachFile extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      onProgress: false,
      attachFileVisible: false,
      attachFile: { accept: [], reject: [] },
      // isUpload - 0: 초기값, 1: 성공, 2: 실패
      uploadResult: { isUpload: 0, message: '' }
    };
  }
  uploadAttachFile = async () => {
    //
  };

  resetAttachFile = () => {
    this.setState({
      onProgress: false,
      attachFile: { accept: [], reject: [] },
      uploadResult: { isUpload: 0, message: '' }
    });
  };

  handleOnDropAttachFile = async files => {
    this.setState({
      uploadResult: { isUpload: 0, message: '' },
      attachFile: { accept: files, reject: [] }
    });

    const { type, setAttachFile } = this.props;

    setAttachFile({ type, file: files });
  };

  handleOnToggleAttachFileModal = () => {
    this.setState({ attachFileVisible: !this.state.attachFileVisible });
  };

  render() {
    const { onProgress, attachFileVisible, attachFile, uploadResult } = this.state;
    const { isAuth } = this.props;
    const { handleOnDropAttachFile, handleOnToggleAttachFileModal, resetAttachFile, uploadAttachFile } = this;

    return (
      <ExamAttachFile
        onProgress={onProgress}
        isAuth={isAuth}
        attachFileVisible={attachFileVisible}
        attachFile={attachFile}
        uploadResult={uploadResult}
        resetAttachFile={resetAttachFile}
        uploadAttachFile={uploadAttachFile}
        handleOnDropAttachFile={handleOnDropAttachFile}
        handleOnToggleAttachFileModal={handleOnToggleAttachFileModal}
      />
    );
  }
}

CtExamAttachFile.propTypes = {};
CtExamAttachFile.defaultProps = {};

const mapStateToProps = state => {
  return {
    isAuth: state.user.get('isAuth'),
    file: state.templateAttach.file
  };
};
const mapDispatchToProps = dispatch => ({
  attachActions: bindActionCreators(attachActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtExamAttachFile));



// WEBPACK FOOTER //
// ./src/script/containers/examTemplate/CtExamAttachFile.js